module.exports = __webpack_public_path__ + "img/Xizang-power.e821d7e9.png";